import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * React Router conserva la posición de scroll al cambiar de ruta, lo que hace
 * que se aterrice a mitad de página. Este componente lleva la vista al inicio
 * en cada navegación.
 *
 * Depende solo de `pathname` a propósito. Si además reaccionara al `state`, la
 * limpieza del destino que hace la home tras desplazarse a una sección se
 * interpretaría como una navegación nueva y devolvería la vista al tope,
 * anulando justamente el scroll que se acababa de hacer.
 *
 * Se exceptúa la navegación que pide una sección concreta: ahí el destino lo
 * decide la página que recibe la navegación.
 */
export default function ScrollToTop() {
    const location = useLocation();

    useEffect(() => {
        if (location.state?.scrollTo) return;
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    return null;
}
